const ua = () => (typeof navigator === 'undefined' ? '' : navigator.userAgent || '');

export const isAndroid = () => /Android/i.test(ua());

/**
 * iPadOS 13+ reports a desktop Macintosh user agent, so touch points are the
 * only thing separating an iPad from a Mac.
 */
export const isMobile = () => {
  const agent = ua();
  if (/Android|iPhone|iPod|iPad/i.test(agent)) return true;
  return /Macintosh/i.test(agent) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1;
};

// The ad networks whose in-app browsers we have measured arriving.
const NAMED_IN_APP = /FBAN|FBAV|FB_IAB|FBIOS|Instagram|musical_ly|Bytedance|TikTok/i;

// Other embedded browsers. `wv` is Android's own WebView marker.
const GENERIC_IN_APP = /; ?wv\)|\bwv\b|Line\/|LinkedInApp|Twitter(?:Android|ForiPhone)|Snapchat|Pinterest|KAKAOTALK|WhatsApp\//i;

export const isInAppBrowser = () => {
  const agent = ua();
  return NAMED_IN_APP.test(agent) || GENERIC_IN_APP.test(agent);
};

/**
 * Whether the WhatsApp handoff needs a page the candidate taps rather than an
 * automatic redirect.
 *
 * A plain desktop browser hands wa.me over without help, so it keeps the
 * redirect. Everything else — every phone, and any embedded browser wherever it
 * runs — gets the tap, because that is the navigation a phone will pass to the
 * WhatsApp app.
 */
export const needsTapHandoff = () => isMobile() || isInAppBrowser();
